import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";

var CalScreenFn = function CalScreenFn() {
  _classCallCheck(this, CalScreenFn);

  this.ratio = 1 / 2;
  this.faceMaskRatio = 375 / 302; //黑色遮罩的宽高逼

  this.handMaskRatio = 1125 / 1014;
  this.faceMaskHeight = 0; //face遮罩的高度

  this.handMaskHeight = 0;
  this.previewHeight = 0; //预览图的高度

  this.previewTopHeight = 0; //橙色部分上部分

  this.previewBottomHeight = 0; //橙色部分下部分

  this.titleBarHeight = 0;
  this.faceMaskHeight = window.screen.width / this.faceMaskRatio;
  this.handMaskHeight = window.screen.width / this.handMaskRatio;
  this.previewHeight = window.screen.width / 3 * 4;
  this.previewTopHeight = (this.previewHeight - this.faceMaskHeight) / 3;
  this.previewBottomHeight = this.previewHeight - this.previewTopHeight;
  this.titleBarHeight = (document.body.clientHeight - window.StatusBar.actualHeight - this.previewHeight) / 3;
};

export default CalScreenFn;